import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import Table from 'react-bootstrap/Table';
import { getFirestore } from "@firebase/firestore";
import { app } from '../../firebase.js';
import { collection, doc, orderBy, setDoc,query, getDocs, deleteDoc, where, updateDoc} from "@firebase/firestore"; 
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import swal from 'sweetalert';
import Spinner from 'react-bootstrap/Spinner';
import { useNavigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { logAdminActivity } from '../../utils/activityLogger';

function CoursesComp() {
  
    const db = getFirestore(app);
    const auth = getAuth();
    let navigate = useNavigate();
  
    const [studentsList, setStudentList] = useState([]);
    const [countAllData, setcountAllData ] = useState(0);
    const [modalShowAdd, setModalShowAdd] = useState(false);
    const [modalShowEdit, setModalShowEdit] = useState(false);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [loading, setLoading] = useState(false);

    const [newCourse, setNewCourse] = useState({
      mcourseName: '',
      mcourseDescription: '',
      mcourseDuration: '',
      courseDuration: '',
      mcoursePrice: '',
      feeDeposit: '',
      feeInstallments: '',
      groupLink: '',
      rank: ''
    });

    const [editCourse, setEditCourse] = useState({
      mcourseName: '',
      mcourseDescription: '',
      mcourseDuration: '',
      courseDuration: '',
      mcoursePrice: '',
      feeDeposit: '',
      feeInstallments: '',
      groupLink: '',
      rank: ''
    });

    const fetchData = async () => {
      const q = query(collection(db, 'courses'), orderBy("rank", 'asc'));
      const querySnapshot = await getDocs(q);
      const studentsItem = [];
      querySnapshot.forEach((doc) => {
        studentsItem.push({ id: doc.id, ...doc.data() });
      });
      setStudentList(studentsItem);
      setcountAllData(studentsItem.length);
    };
  
    useEffect(() => {
      fetchData();
    }, []);
  
    function viewStudent(userId) {
     // navigate('/view-student', { state: { myData: userId } });
    }

    // Helper function to format amounts
    function formatAmount(amount) {
        if (!amount) return ""; // Handle null or undefined values
        const num = parseFloat(amount.replace(/,/g, "")); // Remove existing commas and parse as float
        if (isNaN(num)) return amount; // If not a valid number, return the original string
        return new Intl.NumberFormat().format(num); // Format with commas
    }

    const openViewModal = (course) => {
      navigate(`/course-details/${course.id}`);
    };

    const openEditModal = (course) => {
      setSelectedCourse(course);
      setEditCourse({
        mcourseName: course.mcourseName || '',
        mcourseDescription: course.mcourseDescription || '',
        mcourseDuration: course.mcourseDuration || '',
        courseDuration: course.courseDuration || '',
        mcoursePrice: course.mcoursePrice || '',
        feeDeposit: course.feeDeposit || '',
        feeInstallments: course.feeInstallments || '',
        groupLink: course.groupLink || '',
        rank: course.rank ?? ''
      });
      setModalShowEdit(true);
    };

    const handleNewCourseChange = (field, value) => {
      setNewCourse((prev) => ({ ...prev, [field]: value }));
    };

    const handleEditCourseChange = (field, value) => {
      setEditCourse((prev) => ({ ...prev, [field]: value }));
    };

    const submitNewCourse = async () => {
      if (!newCourse.mcourseName.trim()) {
        swal("Course Name Required", "Please enter the course name.", "error");
        return;
      }
      setLoading(true);
      try {
        const newDataRef = doc(collection(db, "courses"));
        await setDoc(newDataRef, {
          ...newCourse,
          courseId: newDataRef.id,
          rank: newCourse.rank === '' ? null : Number(newCourse.rank)
        });
        logAdminActivity({
          action: 'Add Course',
          details: `Added course ${newCourse.mcourseName}`,
          meta: {
            page: 'Courses',
            courseId: newDataRef.id,
            courseName: newCourse.mcourseName
          }
        });
        setNewCourse({
          mcourseName: '',
          mcourseDescription: '',
          mcourseDuration: '',
          courseDuration: '',
          mcoursePrice: '',
          feeDeposit: '',
          feeInstallments: '',
          groupLink: '',
          rank: ''
        });
        setModalShowAdd(false);
        fetchData();
      } catch (error) {
        swal("Error!", "Failed to add course: " + error.message, "error");
      } finally {
        setLoading(false);
      }
    };

    const submitEditCourse = async () => {
      if (!selectedCourse?.id) return;
      if (!editCourse.mcourseName.trim()) {
        swal("Course Name Required", "Please enter the course name.", "error");
        return;
      }
      setLoading(true);
      try {
        const courseRef = doc(db, "courses", selectedCourse.id);
        await updateDoc(courseRef, {
          ...editCourse,
          courseId: selectedCourse.courseId || selectedCourse.id,
          rank: editCourse.rank === '' ? null : Number(editCourse.rank)
        });
        logAdminActivity({
          action: 'Update Course',
          details: `Updated course ${editCourse.mcourseName}`,
          meta: {
            page: 'Courses',
            courseId: selectedCourse.courseId || selectedCourse.id,
            courseName: editCourse.mcourseName
          }
        });
        setModalShowEdit(false);
        fetchData();
      } catch (error) {
        swal("Error!", "Failed to update course: " + error.message, "error");
      } finally {
        setLoading(false);
      }
    };

    const CourseFormFields = ({ values, onChange }) => (
      <>
        <Form.Group className="mb-3">
          <Form.Label>Course Name</Form.Label>
          <Form.Control type="text" value={values.mcourseName} onChange={(e) => onChange('mcourseName', e.target.value)} />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Course Description</Form.Label>
          <Form.Control as="textarea" rows={4} value={values.mcourseDescription} onChange={(e) => onChange('mcourseDescription', e.target.value)} />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Course Duration (Label)</Form.Label>
          <Form.Control type="text" placeholder="e.g. 10 Months" value={values.mcourseDuration} onChange={(e) => onChange('mcourseDuration', e.target.value)} />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Course Duration (Months)</Form.Label>
          <Form.Control type="number" placeholder="e.g. 10" value={values.courseDuration} onChange={(e) => onChange('courseDuration', e.target.value)} />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Total Fee</Form.Label>
          <Form.Control type="text" value={values.mcoursePrice} onChange={(e) => onChange('mcoursePrice', e.target.value)} />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Fee Deposit</Form.Label>
          <Form.Control type="text" value={values.feeDeposit} onChange={(e) => onChange('feeDeposit', e.target.value)} />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Fee Installments</Form.Label>
          <Form.Control type="text" value={values.feeInstallments} onChange={(e) => onChange('feeInstallments', e.target.value)} />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Group Link</Form.Label>
          <Form.Control type="text" value={values.groupLink} onChange={(e) => onChange('groupLink', e.target.value)} />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Rank</Form.Label>
          <Form.Control type="number" value={values.rank} onChange={(e) => onChange('rank', e.target.value)} />
        </Form.Group>
      </>
    );
  
    return (
      <div className="clientsComp">
          <div className="dataCompTop">
          <h5>All Courses <span class="badge text-bg-warning">{countAllData}</span></h5>
    
            <div className="searchContainer">
              <Button variant="primary" onClick={() => setModalShowAdd(true)}>Add New Course</Button>
            </div>
  
          </div>
    
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Course Name</th>
                <th>Duration</th>
                <th>First Installment</th>
                <th>Installments</th>
                <th>Total Fee</th>
                <th>Edit</th>
                <th>View</th>
              </tr>
            </thead>
            <tbody>
              {studentsList.map((mystudent) => (
                <tr key={mystudent.id}>
                  <td>{mystudent.mcourseName}</td>
                  <td>{mystudent.mcourseDuration}</td>
                  <td>KES {formatAmount(mystudent.feeDeposit)}</td>
                  <td>KES {formatAmount(mystudent.feeInstallments)}</td>
                  <td>KES {formatAmount(mystudent.mcoursePrice)}</td>
                  <td><button className='btn btn-sm btn-warning' onClick={() => openEditModal(mystudent)}>edit</button></td>
                  <td><button className='btn btn-sm btn-primary' onClick={() => openViewModal(mystudent)}>view</button></td>
                </tr>
              ))}
            </tbody>
          </Table>

          <Modal show={modalShowAdd} onHide={() => setModalShowAdd(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title>Add New Course</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <CourseFormFields values={newCourse} onChange={handleNewCourseChange} />
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setModalShowAdd(false)}>Close</Button>
              <Button variant="primary" onClick={submitNewCourse} disabled={loading}>
                {loading ? (
                  <>
                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                    <span> Saving...</span>
                  </>
                ) : (
                  'Save Course'
                )}
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal show={modalShowEdit} onHide={() => setModalShowEdit(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title>Edit Course</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <CourseFormFields values={editCourse} onChange={handleEditCourseChange} />
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setModalShowEdit(false)}>Close</Button>
              <Button variant="primary" onClick={submitEditCourse} disabled={loading}>
                {loading ? (
                  <>
                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                    <span> Saving...</span>
                  </>
                ) : (
                  'Update Course'
                )}
              </Button>
            </Modal.Footer>
          </Modal>

        </div>
  
    )
  }
   
export default CoursesComp
